import { parse } from 'qs'
import { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useAppDispatch } from 'state/hooks'
import { updateReferrer } from 'state/user/reducer'
import { isAddress } from 'utils'

export default function ReferralGetter({ location: { search } }: RouteComponentProps): null {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!search) return
    if (search.length < 1) return

    const parsed = parse(search, {
      parseArrays: false,
      ignoreQueryPrefix: true,
    })

    const ref = parsed.ref
    if (!ref) return

    const referrer = isAddress(ref.toString())

    if (!referrer) return
    dispatch(updateReferrer({ referrer }))
  }, [dispatch, search])

  return null
}
